import { useSearchParams } from "react-router";

import { SMARTFORMS_MODE } from "../constants/generalConstants";
import {
    PO_SUMMARY_PAGE,
    PRODUCT_RESULTS,
    REQUISITION_SUMMARY_PAGE,
} from "../constants/routes";
import { openInvoiceSummaryDialogue } from "./invoiceUtils";
import { openReceiptSummaryDialogue } from "./receiptSummaryUtils";

const ALL = "Product List";
const ITEM_NUMBER = "Item Number";
const SUPPLIER_NUMBER = "Supplier Number";
const REQUISITION_ID = "iBuy Requisition ID";
const PO_NUMBER = "PO Number";
const INVOICE_NUMBER = "Invoice Number";
export const RECEIPT_NUMBER = "Receipt Number";

export const searchBarQueryOptions = [
    ALL,
    ITEM_NUMBER,
    SUPPLIER_NUMBER,
    REQUISITION_ID,
    PO_NUMBER,
    INVOICE_NUMBER,
    RECEIPT_NUMBER,
];

export const searchBarQueryEngine = (
    searchOption,
    searchInput,
    dispatch,
    searchParams,
    setSearchParams
) => {
    /*
    Arguments
    ---------
    searchOption : str
    searchInput : str
    dispatch : func
    */
    switch (searchOption) {
        case ALL: {
            searchParams.set("search_query", searchInput);
            setSearchParams(searchParams);
            return PRODUCT_RESULTS + "?" + searchParams.toString();
        }
        case ITEM_NUMBER: {
            // removed URL params to use searchParams
            searchParams.set("item_number", searchInput);
            searchParams.set("smartforms", SMARTFORMS_MODE);
            searchParams.set("products", SMARTFORMS_MODE);
            setSearchParams(searchParams);
            return PRODUCT_RESULTS + "?" + searchParams.toString();
        }
        case SUPPLIER_NUMBER: {
            // create new search param collection
            const params = new URLSearchParams();
            params.set("supplier_number", searchInput);

            // check if smart forms flag is already exist in the search params
            const smartForms = searchParams.get("smartforms");
            if (smartForms) {
                // keeping existing flag
                params.set("smartforms", smartForms);
            }

            // check if products flag is already exist in the search params
            const products = searchParams.get("products");
            if (products) {
                // keeping existing flag
                params.set("products", products);
            }

            // check if both smart forms and products are not exist in the collection
            if (!params.has("smartforms") && !params.has("products")) {
                // set default values
                params.set("smartforms", SMARTFORMS_MODE);
                params.set("products", SMARTFORMS_MODE);
            }

            return PRODUCT_RESULTS + "?" + params.toString();
        }
        case REQUISITION_ID: {
            return REQUISITION_SUMMARY_PAGE(searchInput);
        }
        case PO_NUMBER: {
            return PO_SUMMARY_PAGE(searchInput);
        }
        case INVOICE_NUMBER: {
            openInvoiceSummaryDialogue(searchInput, dispatch);
            return "";
        }
        case RECEIPT_NUMBER: {
            // No url redirect
            openReceiptSummaryDialogue(searchInput, dispatch);
            return "";
        }
        default: {
            console.warn("Invalid search option input to search engine");
        }
    }
};
